interface BookingCalendarEventProps {
  id: number;
  title: string;
  start: Date;
  end?: Date;
  url?: string;
  className: string;
}

interface BookingCalendarCategoriesProps {
  id: number;
  title: string;
  type: string;
  text: string;
}

const bookingEvents: Array<BookingCalendarEventProps> = [];

const bookingCalendarDefaultCategories: Array<BookingCalendarCategoriesProps> = [
  {
    id: 1,
    title: 'Confirmed',
    type: 'bg-success-subtle',
    text: 'text-success',
  },
  {
    id: 2,
    title: 'Pending',
    type: 'bg-warning-subtle',
    text: 'text-warning',
  },
  {
    id: 3,
    title: 'Cancelled',
    type: 'bg-danger-subtle',
    text: 'text-danger',
  },
];

export { bookingCalendarDefaultCategories, bookingEvents };
